<div *ngIf="isLoading" class="text-center p-5">
  <div class="spinner-border" style="color: var(--mapoh-orange)" role="status">
    <span class="visually-hidden">Cargando...</span>
  </div>
  <p class="mt-2">Cargando datos del dashboard...</p>
</div>

<div *ngIf="!isLoading && hasError" class="text-center p-5">
  <div class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    <strong>Error:</strong> {{ errorMessage }}
  </div>
  <button class="btn btn-primary mt-3" (click)="retryLoadData()">
    <i class="fas fa-refresh me-2"></i>
    Reintentar
  </button>
</div>

<div *ngIf="!isLoading && !hasError && !dashboardData" class="text-center p-5">
  <div class="alert alert-info" role="alert">
    <i class="fas fa-info-circle me-2"></i>
    No hay datos disponibles en el dashboard.
  </div>
</div>

<div *ngIf="!isLoading && dashboardData" class="dashboard-container p-4">
  
  <div class="row">
    <!-- COLUMNA IZQUIERDA: VENTAS -->
    <div class="col-lg-8">
      <!-- Título de Ventas -->
      <div class="d-flex align-items-center mb-3">
        <img src="assets/images/Activity.png" alt="Ventas" width="28" class="me-2">
        <h3 class="m-0">Ventas</h3>
      </div>

      <!-- Ventas periódicas -->
      <div *ngIf="dashboardData.sales">
        <h5 class="text-muted mb-3">Periódicas</h5>
        <div class="row g-3 mb-4">
          <!-- Ventas por día -->
          <div class="col-12 col-md-6 col-lg-4" *ngIf="dashboardData.sales.daily !== undefined">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="fs-4 mb-1">${{ dashboardData.sales.daily | currency:'COP':'symbol':'1.0-0' }}</div>
                <div class="d-flex align-items-center">
                  <img src="assets/images/Calendar.png" alt="Por día" width="20" class="me-2">
                  <span class="text-muted">Por día</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Ventas por mes -->
          <div class="col-12 col-md-6 col-lg-8" *ngIf="dashboardData.sales.monthly !== undefined">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="fs-4 mb-1">${{ dashboardData.sales.monthly | currency:'COP':'symbol':'1.0-0' }}</div>
                <div class="d-flex align-items-center">
                  <img src="assets/images/Calendar.png" alt="Por mes" width="20" class="me-2">
                  <span class="text-muted">Por mes</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Ventas por año -->
          <div class="col-12" *ngIf="dashboardData.sales.yearly !== undefined">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="fs-4">${{ dashboardData.sales.yearly | currency:'COP':'symbol':'1.0-0' }}</div>
                  <div class="d-flex align-items-center">
                    <img src="assets/images/Calendar.png" alt="Por año" width="20" class="me-2">
                    <span class="text-muted">Por Año</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Ventas por servicios -->
      <div *ngIf="dashboardData.services_sales && dashboardData.services_sales.length > 0">
        <h5 class="text-muted mb-3">Por servicios</h5>
        <div class="row g-3">
          <div class="col-12 col-md-6" *ngFor="let service of dashboardData.services_sales">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="mb-1">{{ service.name }}</div>
                <div class="fs-5">${{ service.amount | currency:'COP':'symbol':'1.0-0' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- COLUMNA DERECHA: PERSONAS -->
    <div class="col-lg-4">
      <!-- Título de Personas -->
      <div class="d-flex align-items-center mb-3">
        <img src="assets/images/Profile.png" alt="Personas" width="28" class="me-2">
        <h3 class="m-0">Personas</h3>
      </div>

      <!-- Número de usuarios en la app -->
      <div *ngIf="dashboardData.users">
        <h5 class="text-muted mb-3">Número de usuarios en la app</h5>
        
        <div class="row g-3 mb-4">
          <!-- Aspirantes -->
          <div class="col-12" *ngIf="dashboardData.users.aspirants !== undefined">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="me-3">
                    <img src="assets/images/Group 1000004172.png" alt="Aspirantes" width="32">
                  </div>
                  <div>
                    <div class="fs-3 fw-bold">{{ dashboardData.users.aspirants | number }}</div>
                    <div class="text-muted">Aspirantes</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Matriculados -->
          <div class="col-12" *ngIf="dashboardData.users.enrolled !== undefined">
            <div class="card card-stats shadow-sm">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="me-3">
                    <img src="assets/images/Group 1000004172.png" alt="Matriculados" width="32">
                  </div>
                  <div>
                    <div class="fs-3 fw-bold">{{ dashboardData.users.enrolled | number }}</div>
                    <div class="text-muted">Matriculados</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Número de estudiantes por curso -->
      <div *ngIf="dashboardData.courses">
        <h5 class="text-muted mb-3">Número de estudiantes por curso</h5>
        
        <div class="row g-3">
          <!-- Educación inicial -->
          <div class="col-12" *ngIf="dashboardData.courses.initial_education && dashboardData.courses.initial_education.length > 0">
            <div class="card shadow-sm">
              <div class="card-body">
                <h6 class="mb-3">Educación inicial</h6>
                
                <div class="d-flex justify-content-between mb-2" *ngFor="let course of dashboardData.courses.initial_education">
                  <div>{{ course.name }}</div>
                  <div><strong>{{ course.count }}</strong></div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Tardes -->
          <div class="col-12" *ngIf="dashboardData.courses.afternoon && dashboardData.courses.afternoon.length > 0">
            <div class="card shadow-sm">
              <div class="card-body">
                <h6 class="mb-3">Tardes</h6>
                
                <div class="d-flex justify-content-between mb-2" *ngFor="let course of dashboardData.courses.afternoon">
                  <div>{{ course.name }}</div>
                  <div><strong>{{ course.count }}</strong></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
